import { render, staticRenderFns } from "./NonApprovedVendor.vue?vue&type=template&id=7495434f&scoped=true&"
import script from "./NonApprovedVendor.vue?vue&type=script&lang=js&"
export * from "./NonApprovedVendor.vue?vue&type=script&lang=js&"
import style0 from "./NonApprovedVendor.vue?vue&type=style&index=0&id=7495434f&prod&lang=scss&scoped=true&"
import style1 from "./NonApprovedVendor.vue?vue&type=style&index=1&id=7495434f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495434f",
  null
  
)

export default component.exports